export enum DataHooks {
  DailyTimeSlotsLayout = 'daily-time-slots-layout',
  Timezone = 'timezone',
}
